import { Input } from "@tine/designsystem-ui-react";
import { type ChangeEvent, type FocusEvent, useContext, useState } from "react";
import type { ValidatedInputProps } from "../../common/types/formTypes";
import { FormContext } from "./FormContext";
import { validateNotEmpty } from "./formUtilities/fieldValidators";
import useFormError from "./formUtilities/useFormErrors";
import useRegisterfield from "./formUtilities/useRegisterField";

const ValidatedInput = ({
   initialValue,
   validator = validateNotEmpty,
   label,
   name,
   type = "text",
   required = false,
   ...inputProps
}: ValidatedInputProps) => {
   const [showError, setShowError] = useState(false);
   const { updateFormValues, formValues } = useContext(FormContext);

   const hasMoreThanOneField = Object.keys(formValues).length > 1;

   const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const { value } = e.target;
      setShowError(false);
      updateFormValues({
         ...formValues[name],
         value,
         error: validator(value, required)
      });
      inputProps.onChange?.(e);
   };

   const handleBlur = (e: FocusEvent<HTMLInputElement>) => {
      const { value } = e.target;
      const error = validator(value, required);
      setShowError(!!error);
      updateFormValues({
         ...formValues[name],
         value,
         error
      });
      inputProps.onBlur?.(e);
   };

   useRegisterfield(name, initialValue, validator, required);
   useFormError(setShowError, validator, name, required);

   return (
      <Input
         {...inputProps}
         value={(formValues[name]?.value as string) || ""}
         name={name}
         type={type}
         label={required && hasMoreThanOneField ? `${label} *` : label}
         onFocus={() => setShowError(false)}
         onChange={handleChange}
         onBlur={handleBlur}
         errorMessage={formValues[name]?.error}
         showErrorMessage={showError}
         translate="no"
      />
   );
};

export default ValidatedInput;
